import { AccountHardHatIcon } from './AccountHardHatIcon';

/**
 * author: Austin Andrews
 * id 54665F14-32CD-41E3-B5C5-0E9ABDD3A317
 * name account-hard-hat
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-hard-hat.svg
 * tags
 * - Account / User 
 */
export const ConstructionIcon = AccountHardHatIcon;
export default ConstructionIcon